import { PartsProduct } from '@app/react/const/type';
import { ASSETS_PATH } from '@app/react/const/variables';

export const noProduct = {
    name: '家紋印刷なし',
    productImages: [`${ASSETS_PATH}/svg/kamon-nashi.svg`],
    price: 0,
} as PartsProduct;

export const yesProduct = {
    name: '家紋印刷あり',
    productImages: [`${ASSETS_PATH}/svg/kamon-ari.svg`],
} as PartsProduct;
